import { useLocation, useParams } from "react-router-dom";
import UserPage from "../../components/user";
import { useEffect } from "react";
import { useLazyGetUserByIdDataQuery } from "../../store/api/userApi";
import MainLoader from "../../components/common/loader/main-loader";

const User = () => {
    const { user_id } = useParams();
    const [trigger] = useLazyGetUserByIdDataQuery({ userId: user_id });

    useEffect(() => {
        if (user_id) {
            trigger({ userId: user_id })
        }
    }, [user_id])
    return (
        <div className='min-h-screen w-screen bg-white'>
            <UserPage />
        </div>
    )
}

export default User;